var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('data-table',{ref:"translationList",attrs:{"endpoint":_vm.endpoint,"prefix":"translations","route-context":"settings.template.edit.translation","route-params":{ id: _vm.$route.params.id, template: _vm.$route.meta?.model, subId: { key: 'uuid' } }},on:{"action":_vm.doAction}})
}
var staticRenderFns = []

export { render, staticRenderFns }